import * as React from 'react'
import { useEffect } from 'react'

import { getUser } from 'services/getUser'
import { User } from 'types'

export function useLoggedUser() {
    const [user, setUser] = React.useState<User>()
    useEffect(() => {
        const fetchUser = async () => {
            const result = await getUser()
            setUser(result)
        }
        fetchUser()
    }, [])
    return user
}
